import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h3 className="text-lg font-bold font-heading mb-4">
              欧美大片<span className="text-accent-500">推荐</span>
            </h3>
            <p className="text-sm text-background-300 leading-relaxed">
              致力于为广大影迷提供最新、最全的欧美大片推荐与观影指南。涵盖动作、科幻、悬疑、爱情等多种类型，助你发现每一部值得观看的好电影。
            </p>
          </div>
          <div>
            <h4 className="text-sm font-bold mb-4 text-background-100">电影分类</h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-background-300 hover:text-accent-500 transition-colors duration-200 cursor-pointer">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-bold mb-4 text-background-100">热门文章</h4>
            <ul className="space-y-2">
              <li><Link to="/article/1" className="text-sm text-background-300 hover:text-accent-500 transition-colors duration-200 cursor-pointer">2024年最值得期待的十部好莱坞科幻大片</Link></li>
              <li><Link to="/article/2" className="text-sm text-background-300 hover:text-accent-500 transition-colors duration-200 cursor-pointer">诺兰电影宇宙：叙事革命</Link></li>
              <li><Link to="/article/3" className="text-sm text-background-300 hover:text-accent-500 transition-colors duration-200 cursor-pointer">悬疑片爱好者的终极片单</Link></li>
              <li><Link to="/article/4" className="text-sm text-background-300 hover:text-accent-500 transition-colors duration-200 cursor-pointer">IMDb Top 250深度解析</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-bold mb-4 text-background-100">关于我们</h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-sm text-background-300 hover:text-accent-500 transition-colors duration-200 cursor-pointer">品牌介绍</Link></li>
              <li><Link to="/about" className="text-sm text-background-300 hover:text-accent-500 transition-colors duration-200 cursor-pointer">联系我们</Link></li>
            </ul>
            <div className="flex gap-3 mt-4">
              <a href="#" className="w-9 h-9 rounded-full bg-background-700 flex items-center justify-center text-background-200 hover:bg-accent-500 hover:text-background-50 transition-colors duration-200 cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-background-700 flex items-center justify-center text-background-200 hover:bg-accent-500 hover:text-background-50 transition-colors duration-200 cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-background-700 flex items-center justify-center text-background-200 hover:bg-accent-500 hover:text-background-50 transition-colors duration-200 cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>
        <div className="border-t border-background-700 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400">© 2024 欧美大片推荐. All rights reserved.</p>
          <div className="flex gap-4">
            <a href="#" className="text-xs text-background-400 hover:text-accent-500 transition-colors duration-200 cursor-pointer">隐私政策</a>
            <a href="#" className="text-xs text-background-400 hover:text-accent-500 transition-colors duration-200 cursor-pointer">服务条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}